import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner, Button } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import Download from '@telus-uds/palette-allium/build/web/icons/Download';
import axios from 'axios';

import Confirmation from './confirmation';
import request, { apiHost, config } from '../../../utils/request';

const FilesListRow = ({ fileData, removeFileFromList }) => {
  const { filename, id } = fileData;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteFile = async () => {
    try {
      setConfirmDelete(false);
      setIsDeleting(true);
      const result = await request.delete(`/orders/delete-attachment/${id}`);
      if (result) {
        setIsDeleting(false);
        removeFileFromList(id);
      }
    } catch (error) {
      setIsDeleting(false);
      throw error;
    }
  };

  const onFileDownload = () => {
    const fileExtension = filename
      .split('.')
      .pop()
      .toLowerCase();

    const url = `${apiHost}/orders/attachment/${id}`;
    axios
      .get(url, { ...config(), responseType: `application/${fileExtension}` })
      .then(response => {
        const data = Uint8Array.from(response.data.content.data);
        const blob = new Blob([data.buffer], {
          type: `application/${fileExtension}`
        });
        if (fileExtension === 'pdf') {
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        } else {
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {confirmDelete && (
          <Confirmation
            setConfirmDelete={setConfirmDelete}
            onDeleteFile={onDeleteFile}
            fileName={filename}
          />
        )}
        {!confirmDelete && (
          <Spinner label="" show={isDeleting} inline>
            <div style={{ backgroundColor: 'transparent' }}>{filename}</div>
            <div style={{ backgroundColor: 'transparent' }}>
              <Button
                icon={Download}
                onPress={onFileDownload}
                accessibilityLabel="Download"
                variant={{ text: true }}
              />
              <span style={{ margin: '0 0.5rem' }}></span>
              <Button
                icon={Delete}
                onPress={() => setConfirmDelete(true)}
                accessibilityLabel="Delete"
                variant={{ text: true }}
              />
            </div>
          </Spinner>
        )}
      </li>
    </>
  );
};

FilesListRow.propTypes = {
  fileData: PropTypes.shape({
    filename: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  removeFileFromList: PropTypes.func.isRequired
};

export default FilesListRow;
